import React, { useEffect, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ManOutlined } from "@mui/icons-material";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import SearchBar from "../../../../common/components/FormFields/SearchBar";
import CommonDynamicTablePagination from "../../../../common/components/CommonTable/CommonDynamicTablePagination";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import { DeleteIcon, EditIcon } from "../../../../assets/CommonAssets";
import ItemModel from "./ItemModel";
import { ItemInfoListing} from "../../../../inventory/services/iteminfoservices/Iteminfolistservices";
import { itemFindById, itemSearch } from "../../../services/inventory/item/ItemMasterServices";

function ItemMaster() {
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [count, setCount] = useState();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [dataEdit, setDataEdit] = useState({});
  const [deleteId, setDeleteId] = useState(null);
  const [openChild, setOpenChild] = React.useState(false);
  const [editdatafetch, setEditdatafetch] = React.useState();
  const [searchBar, setSearchBar] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [searchString, setSearchString] = React.useState("");
  const [searchId, setSearchId] = React.useState(null);
  const handelOpenChild = () => setOpenChild(true);
  const handleCloseChild = () => {
    if (openChild) {
      setOpenChild(false);
    }
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const RenderActions = (row, index) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Edit">
            <div value="click" className="text-blue-500 mr-1">
              <EditIcon
                onClick={(e) => {
                  setOpen(true);
                  editRow(row);
                  setEdit(true);
                }}
              />
            </div>
          </Tooltip>
        </div>
        <div>
          <Tooltip title="Delete">
            <div
              className="text-red-500 mr-3"
            // onClick={() => deleteRow(row, index)}
            >
              {<DeleteIcon />}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };

  //findById API Function
  const editRow = (row) => {
    console.log("riow", row);
    itemFindById(row["Item Id"]).then((response) => {
      setEditdatafetch(response.data.result);
    });
  };

  //Listing API Function
  const populateTable = (forPagination) => {
    let searchObj = {
      page: !forPagination ? 0 : page,
      id: searchId ? searchId : null,
      searchString: searchBar ? searchBar : null,
      size: rowsPerPage,
    };
    ItemInfoListing(searchObj)
      .then((response) => response.data)
      .then((res) => {
        console.log("Patient information by id is ", res);
        if (forPagination) {
          setDataResult((prevData) => [...prevData, ...res.result]);
        } else {
          setDataResult(res.result);
          setPage(0);
        }
        setCount(res.count);
      });
  };

  //Autosearch API Function
  const handleChange = (autoSearchString) => {
    setSearchString(autoSearchString);
    console.log("autoSearchString", autoSearchString);
    if (autoSearchString !== "") {
      setSearchBar(autoSearchString);
      itemSearch(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          console.log("res", res.result);
          setOptions(res.result);
        });
    } else if (autoSearchString === "") {
      setSearchBar(null);
    }
  };

  const searchFilde = (value) => {
    console.log("rfx hg", value);
    if (value === null) {
      setSearchString("");
      setSearchId(null);
      setSearchBar("");
      populateTable();
    } else {
      setSearchString(value);
      setSearchId(value.id);
    }
  };
  useEffect(() => {
    populateTable();
  }, [searchBar]);
  return (
    <div>
      <Box sx={{ display: "flex" }}>
       

        <Box component="main" sx={{ flexGrow: 1, p: 3, width: "100%" }}>
       

          <div className="w-full mx-auto ">
            <h1 className="text-xl text-black font-Poppins lg:block md:block">
              Item Master
            </h1>
            <div>
              <div className="flex justify-between w-full items-center mt-2">
                <div className="flex items-center w-full gap-2">


                  <div className=" flex items-center gap-2 text-start w-full xl:w-3/4">
                    {/* searchable */}
                    <SearchBar
                      type="button"
                      name="SearchableSelect"
                      placeholder="Search By Item Code /Name"
                      handleInputChange={handleChange}
                      dataArray={options}
                      onChange={searchFilde}
                      isClearable={true}
                      searchIcon={true}
                    />
                    <div className="flex ">
                      <div className="flex items-center">
                        <CommonButton
                          searchIcon={true}
                          className="bg-blue-800 text-white"
                          type="button"
                          onClick={() => populateTable()}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal and table name start */}
                <div className="flex w-full justify-end">
                  <CommonButton
                    label="+ Add New"
                    className="bg-green-500 text-white"
                    type="submit"
                    onClick={() => {
                      handleOpen();
                      setDataEdit({});
                      setEdit(false);
                    }}
                  />
                </div>

                {/* Backdrop component to disable the screen after submitting the form */}
              </div>
              <CommonBackDrop openBackdrop={openBackdrop} />
              <hr className="w-full border-t-1 border-[#0B83A5] my-2" />
              {dataResult.length > 0 ? (
                <CommonDynamicTablePagination
                  dataResult={dataResult}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  count={count}
                  renderActions={RenderActions}
                  removeHeaders={["Id"]}
                  populateTable={populateTable}
                  actionsRequired={true}
                  highlightRow={false}
                />
              ) : (
                <h1 className="font-semibold text-gray-600 text-center pt-40">
                  {" "}
                  Data Not Found
                </h1>
              )}
              <ItemModel
                open={open}
                setEdit={setEdit}
                editRow={editRow}
                setOpen={setOpen}
                handleClose={handleClose}
                handleOpen={handleOpen}
                edit={edit}
                dataResult={dataResult}
                setDataResult={setDataResult}
                dataEdit={dataEdit}
                setDataEdit={setDataEdit}
                editdatafetch={editdatafetch}
                populateTable={populateTable}
                openBackdrop={openBackdrop}
                setOpenBackdrop={setOpenBackdrop}
              />
            </div>
          </div>
        </Box>
      </Box>
    </div>
  )
}
export default ItemMaster